import { tabCustomSearch } from '@shared/helpers/flights/flights';
import { getCheapestByPrice } from '@shared/pages/Flights/FlightsSearch/helpers';
import { getPerzonalizedSearch } from '@shared/services/services';
import { useEffect, useMemo, useState } from 'react';

const useProcessedCustomSearchResults = flightsSearchBody => {
  const [tabButton, setTabButton] = useState(0);
  const isCustomSearch = tabButton == tabCustomSearch;

  const [flightsCustomDta, setFlightsCustomDta] = useState([]);
  const [optimizedCustomClusters, setOptimizedCustomClusters] = useState([]);

  useEffect(() => {
    if (isCustomSearch && optimizedCustomClusters.length === 0) {
      getPerzonalizedSearch(flightsSearchBody)
        .then(res => {
          const searchCustom = res.clusters.map(cluster => ({
            ...cluster,
            combinations: cluster.combinations.map(combination => ({
              ...combination,
              cluster_id: combination.first_option_cluster_id,
              cluster: res.object_clusters[combination.first_option_cluster_id],
              option: {
                ...combination.option,
                id_option:
                  combination.next_leg_options?.[0]?.first_option_id ??
                  combination.first_option_id,
                ...res.object_options[combination.first_option_hash],
              },
              next_leg_options: combination.next_leg_options?.length
                ? combination.next_leg_options.map(nextLegOption => ({
                    ...nextLegOption,
                    cluster: res.object_clusters[nextLegOption.cluster_id],
                    option: {
                      ...nextLegOption.option,
                      ...res.object_options[nextLegOption.option.hash],
                      first_option_id: nextLegOption.first_option_id,
                    },
                  }))
                : null,
            })),
            common: {
              ...cluster.common,
              common_title: cluster.common.common_title.map(commonTitle => ({
                ...res.object_legs[commonTitle.hash],
              })),
            },
            operation_id: res.operation_id,
          }));

          setFlightsCustomDta(searchCustom);
          setOptimizedCustomClusters(searchCustom);
        })
        .catch(err => console.error('[CustomSearch] error', err));
    }
  }, [
    flightsSearchBody,
    isCustomSearch,
    optimizedCustomClusters.length,
    tabButton,
  ]);

  const customBestPriceByAirline = useMemo(() => {
    return flightsCustomDta
      .map(cluster => {
        const bestCombination = getCheapestByPrice(cluster.combinations);

        if (!bestCombination) return null;

        return {
          ...cluster,
          combinations: [bestCombination],
        };
      })
      .filter(Boolean)
      .sort((a, b) => {
        const priceA =
          a.combinations?.[0]?.cluster?.composition_price?.total ?? Infinity;

        const priceB =
          b.combinations?.[0]?.cluster?.composition_price?.total ?? Infinity;

        return priceA - priceB;
      });
  }, [flightsCustomDta]);

  return {
    tabButton,
    setTabButton,
    isCustomSearch,
    flightsCustomDta,
    setFlightsCustomDta,
    optimizedCustomClusters,
    setOptimizedCustomClusters,
    customBestPriceByAirline,
  };
};

export default useProcessedCustomSearchResults;
